<svelte:options customElement={{
  tag: 'ir-related-cards-slider',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount, onDestroy } from 'svelte';
  import SvgIcon from './SvgIcon.svelte';

  export let items = '[]';

  let parsedItems = [];
  let currentIndex = 0;
  let isMobile = false;
  const slidesPerView = 2;

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('IrRelatedCards: Invalid items JSON', e);
      parsedItems = [];
    }
  }

  function checkMobile() {
    isMobile = window.innerWidth <= 1024;
  }

  function prev() {
    currentIndex = currentIndex > 0 ? currentIndex - 1 : Math.max(0, parsedItems.length - slidesPerView);
  }

  function next() {
    currentIndex = currentIndex < parsedItems.length - slidesPerView ? currentIndex + 1 : 0;
  }

  onMount(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);
  });

  onDestroy(() => {
    window.removeEventListener('resize', checkMobile);
  });
</script>

{#if isMobile}
  <div class="ir-related-cards-carousel">
    <div class="ir-related-cards-carousel__track" style="transform: translateX(-{currentIndex * 50}%)">
      {#each parsedItems as item}
        <div class="ir-related-cards-carousel__slide">
          <a href={item.href || '#'} class="ir-content-card" target={item.blank ? '_blank' : null} rel={item.blank ? 'noopener noreferrer' : null}>
            <div class="ir-content-card__img">
              <img src={item.image || ''} alt={item.alt || ''} />
            </div>
            <div class="ir-content-card__title">
              <span class="ir-content-card__title-inner">
                <SvgIcon name="arrow_right_circle" size="md" />
                <span class="_text">{item.title || ''}</span>
              </span>
            </div>
          </a>
        </div>
      {/each}
    </div>

    {#if parsedItems.length > 1}
      {#if currentIndex > 0}
        <button type="button" class="ir-related-cards-carousel__prev" on:click={prev} aria-label="前へ">
          <svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg>
        </button>
      {/if}
      {#if currentIndex < parsedItems.length - slidesPerView}
        <button type="button" class="ir-related-cards-carousel__next" on:click={next} aria-label="次へ">
          <svg viewBox="0 0 24 24"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg>
        </button>
      {/if}
    {/if}
  </div>
{:else}
  <div class="ir-related-cards">
    {#each parsedItems as item}
      <a href={item.href || '#'} class="ir-content-card" target={item.blank ? '_blank' : null} rel={item.blank ? 'noopener noreferrer' : null}>
        <div class="ir-content-card__img">
          <img src={item.image || ''} alt={item.alt || ''} />
        </div>
        <div class="ir-content-card__title">
          <span class="ir-content-card__title-inner">
            <SvgIcon name="arrow_right_circle" size="md" />
            <span class="_text">{item.title || ''}</span>
          </span>
        </div>
      </a>
    {/each}
  </div>
{/if}

<style>
  .ir-related-cards-carousel {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .ir-related-cards-carousel__track {
    display: flex;
    transition: transform 0.5s ease;
  }

  .ir-related-cards-carousel__slide {
    flex: 0 0 50%;
    min-width: 50%;
  }

  .ir-related-cards-carousel__slide .ir-content-card {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .ir-related-cards-carousel__prev,
  .ir-related-cards-carousel__next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.65);
    backdrop-filter: blur(2.6315789222717285px);
    transition: background 0.3s;
    z-index: 1;
    padding: 0;
  }

  .ir-related-cards-carousel__prev {
    left: 10px;
  }

  .ir-related-cards-carousel__next {
    right: 10px;
  }

  .ir-related-cards-carousel__prev svg,
  .ir-related-cards-carousel__next svg {
    width: 16px;
    height: 16px;
    fill: #000;
  }
</style>